import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";

import pages from "../../../constants/pages";
import { colors } from "../../css components/Style";
import Collapse from "../../../assets/auth carousel pics/audiece_target.png";

const OuterDiv = styled.div`
  background: ${colors.green};
  border-radius: 10px;
  padding: 20px 20px;
`;

export default function ExploreConnection({ formikProps }) {
  const navigate = useNavigate();

  return (
    <OuterDiv>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Typography className="explore-connection-text">
            Get connected with partners who drive higher conversions with
            targeted audience
          </Typography>
        </Grid>

        <Grid size={12}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              className="explore-connection-button"
              onClick={() =>
                navigate(
                  pages.exploreConnections.route +
                    "?campaignID=" +
                    formikProps.values.campaignID
                )
              }
            >
              Explore Connections
            </div>

            <img
              className="explore-connection-image"
              src={Collapse}
              alt="!"
            ></img>
          </div>
        </Grid>
      </Grid>
    </OuterDiv>
  );
}
